import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export const getBannerConfig = (bannerType) => {
    switch (bannerType) {
        case "SUCCESS":
            return {
                icon: faCheckCircle, color: '#4caf50', backgroundColor: '#d5e6de',
            };
        case "INFO":
            return {
                icon: faInfoCircle, color: '#2196f3', backgroundColor: '#d6f3fb'
            };
        case "WARNING":
            return {
                icon: faExclamationTriangle, color: '#ff9800', backgroundColor: '#fdf3d1',
            };
        case "DANGER":
            return {
                icon: faTimesCircle, color: '#f44336', backgroundColor: '#f3d8da'
            };
        default:
            return {
                icon: faInfoCircle, color: '#666', backgroundColor: '#f0f0f0',
            };
    }
}